module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-grid-medium",
    attrs: {
      "uk-grid": ""
    }
  }, [(_vm.ShopFilterProperties.length !== 0) ? _c('filters', {
    attrs: {
      "filter-properties": _vm.page.ShopFilterProperties,
      "filter-property-values": _vm.page.ShopFilterPropertyValues,
      "selected-property-values": _vm.page.selectedPropertyValues
    },
    on: {
      "filter-changed": _vm.filterChanged
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-1 uk-width-expand@m"
  }, [_c('div', {
    staticClass: "uk-grid-medium uk-child-width-1-1",
    attrs: {
      "uk-grid": ""
    }
  }, [(_vm.ShopGroup) ? _c('div', [_c('div', {
    staticClass: "uk-grid-small tm-all-tags",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.ShopTags), function(ShopTag) {
    return _c('shop-tag', {
      key: ShopTag.id,
      attrs: {
        "shop-tag": ShopTag,
        "shop-items": _vm.page.ShopItems.items,
        "shop-item-tags": _vm.page.ShopItemTags
      }
    })
  }))]) : _vm._e(), _vm._v(" "), _c('shop-items-pagination', _vm._g({
    attrs: {
      "total-pages": _vm.page.ShopItems.total_pages,
      "last-page": _vm.page.ShopItems.last,
      "current-page": _vm.page.ShopItems.current,
      "next-page": _vm.page.ShopItems.next,
      "previous-page": _vm.page.ShopItems.before
    },
    on: {
      "load-page": _vm.loadPage
    }
  }, _vm.$listeners)), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "uk-grid-medium uk-child-width-1-1 uk-child-width-1-2@s js-list-item-cards",
    class: [_vm.page.ShopFilterProperties.length !== 0 ? 'uk-child-width-1-3@l' : 'uk-child-width-1-4@l'],
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.page.ShopItems.items), function(Product) {
    return _c('div', [_c('shop-item-block', {
      key: Product.ShopItem.id,
      attrs: {
        "shop-item": Product.ShopItem,
        "shop-item-prices": _vm.page.ShopItemPrices[Product.ShopItem.id],
        "shop-item-properties": _vm.page.ShopItemProperties[Product.ShopItem.id],
        "shop-item-warehouses": _vm.page.ShopItemWarehouses[Product.ShopItem.id],
        "shop-item-tags": _vm.page.ShopItemTags[Product.ShopItem.id],
        "shop-order-item": _vm.page.ShopOrderItems[Product.ShopItem.id]
      },
      on: {
        "buy-shop-item": _vm.buy
      }
    })], 1)
  }))]), _vm._v(" "), _c('shop-items-pagination', _vm._g({
    attrs: {
      "total-pages": _vm.page.ShopItems.total_pages,
      "last-page": _vm.page.ShopItems.last,
      "current-page": _vm.page.ShopItems.current,
      "next-page": _vm.page.ShopItems.next,
      "previous-page": _vm.page.ShopItems.before
    },
    on: {
      "load-page": _vm.loadPage
    }
  }, _vm.$listeners))], 1), _vm._v(" "), _c('a', {
    staticClass: "uk-button uk-button-primary",
    staticStyle: {
      "display": "none",
      "margin-left": "20px"
    },
    attrs: {
      "id": "js-scroll"
    }
  })]), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading,
      "label": ""
    }
  }, [_c('template', {
    slot: "loading-spinner"
  }, [_c('div', {
    attrs: {
      "uk-spinner": "ratio: 2"
    }
  })])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e4e4b2a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Shop/ShopGroup/ShopItemsList.vue
// module id = 85
// module chunks = 0